export default "__VITE_ASSET__yY$IFi0S__"